import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { RewardExperienceController } from './controllers/Reward.experience';

const App: React.FunctionComponent = () => <BrowserRouter>
  <Routes>
    <Route element={<RewardExperienceController />} path="/" />
  </Routes>
</BrowserRouter>;
export default App;
